import { CustomTextField } from '@/components/Formik/CustomTextField';
import { InfoOutlined } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Box, Typography } from '@mui/material';
import { useFormikContext } from 'formik';

interface ICompanySlugProps {
  isSubmitting: boolean;
}

const CompanySlug = ({ isSubmitting }: ICompanySlugProps) => {
  const { handleSubmit } = useFormikContext();
  return (
    <>
      <Typography
        variant="h6"
        sx={{
          mb: '4px',
          textAlign: 'left',
        }}
      >
        Link amigável da sua empresa
      </Typography>
      <Typography
        variant="body2"
        sx={{
          textAlign: 'left',
          mb: 2,
        }}
      >
        Defina um nome para compartilhar o link amigável da sua empresa
      </Typography>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          color: 'text.primary',
        }}
      >
        <Typography sx={{ minWidth: 'max-content' }}>
          site.obraplay.com/
        </Typography>
        <CustomTextField
          variant="standard"
          placeholder="minha-empresa"
          name="slug"
          fullWidth
          inputProps={{
            onChange: e => {
              e.currentTarget.value = e.currentTarget.value.toLowerCase();
            },
          }}
        />
      </Box>
      <Box
        component="section"
        sx={{
          mt: 2,
          backgroundColor: 'rgba(0, 0, 0, 0.05)',
          color: '#9A9A9A',
          borderRadius: '8px',
          p: 2,
          display: 'flex',
          alignItems: 'center',
          gap: '20px',
          position: 'relative',
        }}
      >
        <InfoOutlined
          sx={{
            display: 'flex',
            textAlign: 'right',
          }}
        />
        <Box sx={{ flex: '1', paddingRight: 'calc(40px - 16px)' }}>
          <Typography
            variant="caption"
            sx={{
              mb: '4px',
            }}
          >
            Você pode usar a-z, 0-9, hífen (-) e underline (_). O tamanho mínimo
            é de 3 caracteres e deve conter ao menos uma letra.
          </Typography>
        </Box>
      </Box>
      <LoadingButton
        loading={isSubmitting}
        variant="contained"
        className="submitButton"
        onClick={() => handleSubmit()}
        fullWidth
      >
        Próximo
      </LoadingButton>
    </>
  );
};

export default CompanySlug;
export type { ICompanySlugProps };
